import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = {
  class: "accordion accordion-flush accordion-icon-toggle",
  id: "kt_accordion_2"
}
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = {
  class: "accordion-header py-3 d-flex",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_4"
}
const _hoisted_6 = { class: "accordion-icon" }
const _hoisted_7 = { class: "svg-icon svg-icon-3" }
const _hoisted_8 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_accordion_2_item_4\" class=\"fs-6 collapse show ps-10\" data-bs-parent=\"#kt_accordion_2\"><h4 class=\"fs-6 fw-bold mb-1\">New:</h4><ul class=\"py-2\"><li class=\"py-2\">Migration to new icons set.</li><li class=\"py-2\"> Migration to new illustrations set. </li></ul><h4 class=\"fs-6 fw-bold mb-1\">Fix:</h4><ul class=\"py-2\"><li class=\"py-2\">Fixed installation errors.</li><li class=\"py-2\"> Duplicated drawer bug then open main layout pages. </li></ul></div>", 1)
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_3"
}
const _hoisted_12 = { class: "accordion-icon" }
const _hoisted_13 = { class: "svg-icon svg-icon-3" }
const _hoisted_14 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_accordion_2_item_3\" class=\"fs-6 collapse ps-10\" data-bs-parent=\"#kt_accordion_2\"><h4 class=\"fs-6 fw-bold mb-1\">New:</h4><ul class=\"py-2\"><li class=\"py-2\">Added purchase drawer page.</li><li class=\"py-2\"> Added private chat page. <a href=\"https://preview.keenthemes.com/start-vue-pro/#/apps/chat/private-chat\">Live preview</a></li><li class=\"py-2\"> Added group chat page. <a href=\"https://preview.keenthemes.com/start-vue-pro/#/apps/chat/group-chat\">Live preview</a></li><li class=\"py-2\"> Added drawer chat page.<a href=\"https://preview.keenthemes.com/start-vue-pro/#/apps/chat/drawer-chat\">Live preview</a></li></ul></div>", 1)
const _hoisted_16 = { class: "mb-5" }
const _hoisted_17 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_2"
}
const _hoisted_18 = { class: "accordion-icon" }
const _hoisted_19 = { class: "svg-icon svg-icon-3" }
const _hoisted_20 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_accordion_2_item_2\" class=\"fs-6 collapse ps-10\" data-bs-parent=\"#kt_accordion_2\"><h4 class=\"fs-6 fw-bold mb-1\">New:</h4><ul class=\"py-2\"><li class=\"py-2\"> New Element UI framework integration. <a href=\"https://preview.keenthemes.com/start-vue-pro/#/documentation/element-ui/basic/layout\">Live preview</a>. </li><li class=\"py-2\"> New form validation plugin VeeValidate. <a href=\"https://preview.keenthemes.com/start-vue-pro/#/documentation/vee-validate\">Live preview</a>. </li></ul><h4 class=\"fs-6 fw-bold mb-1\">Fix:</h4><ul class=\"py-2\"><li class=\"py-2\">Fixed chart initialization issue in sidebar.</li><li class=\"py-2\"> Fixed bug with aside offcanvas on mobile versions. </li></ul><h4 class=\"fs-6 fw-bold mb-1\">Update:</h4><ul class=\"py-2\"><li class=\"py-2\"> Updated bootstrap version form <code>5.0.0-beta1</code> to <code>5.0.0-beta3</code>. </li></ul></div>", 1)
const _hoisted_22 = { class: "mb-5" }
const _hoisted_23 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_item_1"
}
const _hoisted_24 = { class: "accordion-icon" }
const _hoisted_25 = { class: "svg-icon svg-icon-3" }
const _hoisted_26 = { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt_accordion_2_item_1",
  class: "fs-6 collapse ps-10",
  "data-bs-parent": "#kt_accordion_2"
}, [
  /*#__PURE__*/_createElementVNode("ul", { class: "py-2" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "py-2" }, "Initial release.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
              ])
            ]),
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.themeName) + " v1.0.3 - 28 February, 2022 ", 1)
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
              ])
            ]),
            _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.themeName) + " v1.0.2 - 11 June, 2021 ", 1)
          ]),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
              ])
            ]),
            _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.themeName) + " v1.0.1 - 13 April, 2021 ", 1)
          ]),
          _hoisted_21
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
              ])
            ]),
            _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.themeName) + " v1.0.0 - 13 March, 2021 ", 1)
          ]),
          _hoisted_27
        ])
      ])
    ])
  ]))
}